import { miniauniversity, hackathon, htmlsololearn, htmcssmahara, pythonhacker, javahacker, djangobarmeg, fullstackbarmeg, uxuiudemy, communication } from '../../../images/images';

export const CertDataAr = [
	{
		'img': miniauniversity,
		'des': 'شهادة جامعة المنيا',
		'i':5,
	},
	{
		'img': communication,
		'des': 'شهادة وزارة الاتصالات',
		'i':2,
	},
	{
		'img': hackathon,
		'des': 'شهادة هاكثون شراكة مع موجود',
		'i':3,
	},
	{
		'img': htmlsololearn,
		'des': 'شهادة اتش تي ام ال منصة سولو ليرن',
		'i':4,
	},
	{
		'img': htmcssmahara,
		'des': 'شهادة اتش تي ام ال و سي اس اس مهاره تك',
		'i':5,
	},
	{
		'img': pythonhacker,
		'des': 'شهادة بايثون منصة هاكر رانك',
		'i':6,
	},
	{
		'img': javahacker,
		'des': 'شهادة جافاسكريبت منصة هاكر رانك',
		'i':7,
	},
	{
		'img': djangobarmeg,
		'des': 'شهادة دجانفو برمج',
		'i': 8,
	},
	{
		'img': fullstackbarmeg,
		'des': 'شهادة مطور ويب برمج',
		'i': 9,
	},
	{
		'img': uxuiudemy,
		'des': 'شهادة التصميم يوديمي',
		'i': 10,
	}

];